module.exports = __webpack_public_path__ + "img/2800m.0960e9c6.png";